define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"underscore",
	"csi/core/Key",
	"csi/store/Nodes",
	"csi/table/Widget",
	"csi/xml",
	"./CareInstructionsTableController"
], function(declare, lang, _, Key, Nodes, Table, xml, CareInstructionsTable) {

	return declare(CareInstructionsTable, {
		bResetStore: false,
		bPrefImageSizeInMatrix: true,

		/**
		 * @override
		 * Hide special headings is sales region not selected
		 */
		onViewResolveKeysToSkip(skipSet) {
			if (!xml.isValidURL(this.activeProductSalesRegion)) {
				skipSet.add(Key.untypedKeyFromParts({
					name: "CareIconsMatrix",
				}));
				skipSet.add(Key.untypedKeyFromParts({
					name: "ProductSalesRegionSpec",
				}));
			}
		},

		onViewStart: function(/*Deferred[]*/dfds) {
			// summary: make each heading read-only except for Node Name
			_.each(this.defView.m_headings, (h) => {
				if (h.m_id != xml.ATTR_NAME) {
					h.m_right = xml.RIGHT_NONE;
				} else if (this.getViewNode() && xml.nodeIsFrozen(this.getViewNode())) { //C8-6759: Node Name should not be editable when the data sheet is frozen
					if (h.m_action) {
						h.m_action.m_right = xml.RIGHT_NONE;
					}
				}
			});

			Table.prototype.onViewStart.call(this);
		},

		_createQueryLevel: function(/*Object*/params, /*Boolean*/bRoot) {
			// summary: convert table entries into fake nodes
			var ql = this.inherited(arguments);
			if (ql.bMain) {
				ql.createCustomStore = lang.hitch(this, function() {
					return new Nodes({
						cachingStore: this.cacheView,
						data: this._createRowNodes()
					});
				});
			}
			return ql;
		},

		_createRowNodes: function() {
			// summary: create a fake node for each table row
			var careAndCompDSRev = this.getViewNode();
			return _.map(careAndCompDSRev.CareSymbolTypes, function(careSymbolType) {
				var node;
				var index = careAndCompDSRev.CareSymbolTypes.indexOf(careSymbolType);
				var currentCareIconURL = careAndCompDSRev.CareIcons[index];
				if (xml.isValidURL(currentCareIconURL)) {
					node = this.getCache().getNode(currentCareIconURL);
				} else {
					node = xml.nodeCreateClientNode(null, "CareSymbol", "", null, 0);
					xml.nodeCreateClientAttr(node, "SymbolType", xml.ATTR_ENUM, careSymbolType);
				}
				return node;
			}, this);
		}

	});
});